export const manifest = {
  screens: {
    scr_6lsmye: { name: "Scorecard", route: "/", state: {"page":"scorecard"}, position: {"x":160,"y":220} },
    scr_xq89oo: { name: "Point System", route: "/", state: {"page":"points"}, position: {"x":1560,"y":220} },
    scr_zrq06w: { name: "Career Progression", route: "/", state: {"page":"career"}, position: {"x":2960,"y":220} },
    scr_nk5bbr: { name: "Admin · Team Points", route: "/", state: {"page":"admin"}, position: {"x":4360,"y":220} },
  },
  sections: {
    sec_9cy8mu: { name: "Dashboard", x: 0, y: 0, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_9cy8mu", children: [
      { kind: "screen", id: "scr_6lsmye" },
      { kind: "screen", id: "scr_xq89oo" },
      { kind: "screen", id: "scr_zrq06w" },
      { kind: "screen", id: "scr_nk5bbr" },
    ] },
  ],
}
